function logErr(label, err) {
  console.error(`[BSS] ${label}`, err);
}

(function () {
  const RECO_SEL = '[data-bs-scroll]';

  function rootPath() {
    return (window.Shopify?.routes?.root) ? Shopify.routes.root : '/';
  }

  function money(cents) {
    if (window.Shopify?.formatMoney) {
      try {
        const fmt = window.Shopify?.money_format || "{{amount_with_currency}}";
        return window.Shopify.formatMoney(cents, fmt);
      } catch {}
    }
    const currency = window.Shopify?.currency?.active || 'EUR';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((cents || 0) / 100);
    } catch {
      return (cents || 0) / 100;
    }
  }

  /* -------------------------
     Recommendations rendering
  -------------------------- */
  function getImg(p) {
    if (typeof p.featured_image === 'string') return p.featured_image;
    if (p.featured_image?.url) return p.featured_image.url;
    return '';
  }

  function getFirstAvailableVariant(p) {
    const variants = Array.isArray(p.variants) ? p.variants : [];
    return variants.find(v => v && v.available) || null;
  }

 function buildRecoCard(p) {
  const variants = Array.isArray(p.variants) ? p.variants : [];
  const firstAvail = variants.find(v => v && v.available) || variants[0] || null;

  const img = getImg(p);
  const imgSrc = img ? `${img}${img.includes('?') ? '&' : '?'}width=220` : '';

  const price = (typeof p.price === 'number') ? p.price : (firstAvail?.price ?? 0);
  const compare = (typeof p.compare_at_price === 'number') ? p.compare_at_price : (firstAvail?.compare_at_price ?? 0);

  // Build options (only if >1 variant)
  const hasVariantPicker = variants.length > 1;

  // For dropdown: show title and disable sold-out variants
  const variantOptions = variants.map(v => {
    const disabled = v.available ? '' : 'disabled';
    const suffix = v.available ? '' : ' (Uitverkocht)';
    // `v.title` in Shopify product JSON is usually like "S/M" or "Default Title"
    return `<option value="${v.id}" ${disabled}>${v.title}${suffix}</option>`;
  }).join('');

  const initialVariantId = firstAvail?.id || '';

  const isAvailable = !!(firstAvail && firstAvail.available);

  return `
    <div class="bs-scroll__slide" data-slide>
      <div class="bs-scroll__card">
        <a class="bs-scroll__media" href="${p.url}">
          ${imgSrc ? `<img class="bs-img" src="${imgSrc}" loading="lazy" alt="">` : ''}
        </a>

        <div class="bs-scroll__info">
          <a class="bs-scroll__title" href="${p.url}">${p.title}</a>
          <div class="bs-scroll__price">
            ${
              (compare && compare > price)
                ? `<span class="bs-scroll__price-sale">${money(price)}</span>
                   <s class="bs-scroll__price-compare">${money(compare)}</s>`
                : `<span>${money(price)}</span>`
            }
          </div>
        </div>

        <div class="bs-scroll__cta">
          ${
            hasVariantPicker
              ? `<select class="bs-scroll__variant" data-variant-select>
                   ${variantOptions}
                 </select>`
              : ``
          }

          ${
            isAvailable
              ? `<button class="bs-scroll__btn js-ajax-add bs-cta"
                    data-variant-id="${initialVariantId}" type="button">
                    In winkelwagen
                 </button>`
              : `<button class="bs-scroll__btn bs-scroll__btn--disabled" type="button" disabled>
                    Uitverkocht
                 </button>`
          }
        </div>
      </div>
    </div>
  `;
}

  /* -------------------------
     Dots (idempotent, no leaks)
  -------------------------- */
  function setupDotsForSection(section) {
    const viewport = section.querySelector('[data-viewport]');
    const dotsWrap = section.querySelector('[data-dots]');
    if (!viewport || !dotsWrap) return;

    const slides = Array.from(viewport.querySelectorAll('[data-slide]'));
    if (slides.length <= 1) {
      dotsWrap.innerHTML = '';
      return;
    }

    // Rebuild dots HTML (safe)
    dotsWrap.innerHTML = slides.map((_, i) => `
      <button class="bs-scroll__dot ${i === 0 ? 'is-active' : ''}"
        type="button" data-dot="${i}"
        aria-label="Go to slide ${i + 1}"
        ${i === 0 ? 'aria-current="true"' : ''}></button>
    `).join('');

    const dots = Array.from(dotsWrap.querySelectorAll('[data-dot]'));

    function setActive(i) {
      dots.forEach((d, di) => {
        d.classList.toggle('is-active', di === i);
        if (di === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    function slideLeft(i) {
      const slide = slides[i];
      return slide ? slide.offsetLeft : 0;
    }

    function scrollToIndex(i) {
      const left = slideLeft(i);
      try { viewport.scrollTo({ left, behavior: 'smooth' }); }
      catch { viewport.scrollLeft = left; }
      setActive(i);
    }

    // Bind once per section
    if (!section.dataset.dotsBound) {
      section.dataset.dotsBound = '1';

      dotsWrap.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-dot]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        const i = parseInt(btn.getAttribute('data-dot'), 10) || 0;
        scrollToIndex(i);
      }, true);

      let raf = null;
      viewport.addEventListener('scroll', () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const left = viewport.scrollLeft;
          let best = 0, bestDist = Infinity;
          slides.forEach((_, i) => {
            const dist = Math.abs(slideLeft(i) - left);
            if (dist < bestDist) { bestDist = dist; best = i; }
          });
          setActive(best);
        });
      }, { passive: true });
    } else {
      setActive(0);
    }
  }

  /* -------------------------
     Fetch + render recommendations
     (no global MutationObserver)
  -------------------------- */
  function setupArrowsForSection(section) {
  const viewport = section.querySelector('[data-viewport]');
  const prev = section.querySelector('[data-arrow="prev"]');
  const next = section.querySelector('[data-arrow="next"]');
  if (!viewport || !prev || !next) return;

  const slides = () => Array.from(viewport.querySelectorAll('[data-slide]'));

  function currentIndex() {
    const left = viewport.scrollLeft;
    const s = slides();
    let best = 0, bestDist = Infinity;
    s.forEach((el, i) => {
      const dist = Math.abs(el.offsetLeft - left);
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    return best;
  }

  function scrollToIndex(i) {
    const s = slides();
    const el = s[i];
    if (!el) return;
    try { viewport.scrollTo({ left: el.offsetLeft, behavior: 'smooth' }); }
    catch { viewport.scrollLeft = el.offsetLeft; }
  }

  function updateDisabled() {
    const i = currentIndex();
    const s = slides();
    prev.disabled = i <= 0;
    next.disabled = i >= s.length - 1;
  }

  if (!section.dataset.arrowsBound) {
    section.dataset.arrowsBound = '1';

    prev.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      scrollToIndex(Math.max(0, currentIndex() - 1));
    }, true);

    next.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      const s = slides();
      scrollToIndex(Math.min(s.length - 1, currentIndex() + 1));
    }, true);

    viewport.addEventListener('scroll', updateDisabled, { passive: true });
  }

  updateDisabled();
}
  async function loadRecoForSection(section) {
    const productId = section.dataset.productId;
    const limit = parseInt(section.dataset.limit || '3', 10);
    const intent = section.dataset.intent || 'related';
    const viewport = section.querySelector('[data-viewport]');
    if (!viewport) return;

    if (!productId) {
      section.style.display = 'none';
      return;
    }

    // Prevent spam refetch unless we explicitly reset it
    if (section.dataset.recoLoaded === '1') return;

    const url =
      `${rootPath()}recommendations/products.json` +
      `?product_id=${encodeURIComponent(productId)}` +
      `&limit=${encodeURIComponent(limit)}` +
      `&intent=${encodeURIComponent(intent)}`;

    try {
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) return (section.style.display = 'none');

      const data = await res.json();
      const products = data?.products || [];
      if (!products.length) return (section.style.display = 'none');

      section.style.display = '';
      viewport.innerHTML = products.slice(0, limit).map(buildRecoCard).join('');
      setupDotsForSection(section);
      setupArrowsForSection(section);
      section.dataset.recoLoaded = '1';
    } catch (e) {
      section.style.display = 'none';
    }
  }

  function initRecoAll() {
    document.querySelectorAll(RECO_SEL).forEach(loadRecoForSection);
  }

  /* -------------------------
     Add-to-cart using your THEME form
     (prevents redirect + updates drawer)
  -------------------------- */
  function getThemeAddForm() {
    // This is the exact one you confirmed exists
    return document.querySelector('form.f8pr.f8pr-anchor.f8pr-buy-button.cart-initialized');
  }
  async function ajaxAddViaThemeForm(variantId, button) {
  try {
    button.disabled = true;

    const themeForm = document.querySelector('form.f8pr.f8pr-anchor.f8pr-buy-button.cart-initialized');

    // ✅ BEST PATH: Use the theme form by clicking its submit button (most reliable)
    if (themeForm) {
      let idInput = themeForm.querySelector('input[name="id"]');
      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        themeForm.appendChild(idInput);
      }

      // Use hidden quantity to avoid touching PDP qty UI
      let qtyInput = themeForm.querySelector('input[name="quantity"].bs-hidden-qty');
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.className = 'bs-hidden-qty';
        themeForm.appendChild(qtyInput);
      }

      const originalId = idInput.value;
      const originalQty = qtyInput.value;

      idInput.value = String(variantId);
      qtyInput.value = '1';

      const submitBtn = themeForm.querySelector('button[type="submit"], input[type="submit"]');

      if (submitBtn) {
        // ✅ This is what the theme reliably intercepts
        submitBtn.click();
      } else if (typeof themeForm.requestSubmit === 'function') {
        themeForm.requestSubmit();
      } else {
        themeForm.submit();
      }

      // restore values after theme intercept
      setTimeout(() => {
        idInput.value = originalId;
        qtyInput.value = originalQty;

        // Let recos refresh (optional)
        document.querySelectorAll(RECO_SEL).forEach((s) => { s.dataset.recoLoaded = '0'; });
        initRecoAll();

        button.disabled = false;
      }, 800);

      return;
    }

    // ✅ FALLBACK PATH: add.js (if theme form doesn't exist on this page)
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    if (!addRes.ok) {
      let msg = 'Add failed';
      try {
        const j = await addRes.json();
        msg = j?.description || j?.message || msg;
      } catch {}
      console.error('[BSS] add.js failed:', msg);
      return;
    }

    // ✅ Force the theme drawer to refresh like a qty/remove flow
    [0, 120, 350, 700].forEach((ms) => {
      setTimeout(() => {
        observeCartDrawer();
        triggerThemeDrawerRefresh();
      }, ms);
    });

    // Refresh recos (optional)
    setTimeout(() => {
      document.querySelectorAll(RECO_SEL).forEach((s) => { s.dataset.recoLoaded = '0'; });
      initRecoAll();
    }, 700);

  } catch (err) {
    logErr('ajaxAdd failed', err);
  } finally {
    setTimeout(() => { button.disabled = false; }, 1500);
  }
}

  /* -------------------------
     Click handler (single listener)
  -------------------------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-ajax-add');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    ajaxAddViaThemeForm(variantId, btn);
  }, true);
// 🔁 Update button when variant dropdown changes
document.addEventListener('change', function (e) {
  const select = e.target.closest('[data-variant-select]');
  if (!select) return;

  const slide = select.closest('[data-slide]');
  const btn = slide ? slide.querySelector('.js-ajax-add') : null;
  if (!btn) return;

  btn.dataset.variantId = select.value;

  const opt = select.selectedOptions && select.selectedOptions[0];
  if (opt && opt.disabled) {
    btn.disabled = true;
    btn.classList.add('bs-scroll__btn--disabled');
    btn.textContent = 'Uitverkocht';
  } else {
    btn.disabled = false;
    btn.classList.remove('bs-scroll__btn--disabled');
    btn.textContent = 'In winkelwagen';
  }
}, true);
  /* -------------------------
     Init once
  -------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecoAll);
  } else {
    initRecoAll();
  }

  // If Theme Editor reloads sections
  document.addEventListener('shopify:section:load', () => {
    // allow re-fetch in editor
    document.querySelectorAll(RECO_SEL).forEach((s) => { s.dataset.recoLoaded = '0'; });
    initRecoAll();
  });

  // ✅ Re-init when the drawer content is injected (scoped, throttled)
function observeCartDrawer() {
  const cart = document.querySelector('aside#cart');
  if (!cart) return;

  // If the cart node is replaced, we need to re-observe the new one
  if (cart.dataset.bsRecoObserved === '1') return;
  cart.dataset.bsRecoObserved = '1';

  let raf = null;
  const obs = new MutationObserver(() => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;

      const sections = cart.querySelectorAll(RECO_SEL);
      if (!sections.length) return;

      // init only if needed
      for (const s of sections) {
        if (s.dataset.recoLoaded !== '1') {
          initRecoAll();
          break;
        }
      }
    });
  });

  obs.observe(cart, { childList: true, subtree: true });
}

function triggerThemeDrawerRefresh() {
    const cart = document.querySelector('aside#cart');
    if (!cart) return false;

    // Try the most common “theme refresh” hook: qty input change
    const qty = cart.querySelector('input[name="updates[]"].disable-on-change, input[name="updates[]"]');
    if (qty) {
        const v = qty.value;
        qty.value = v; // no-op
        qty.dispatchEvent(new Event('input', { bubbles: true }));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
    }

    // Fallback: click handler based refresh (rare)
    const removeLink = cart.querySelector('.remove-from-cart-link');
    if (removeLink) {
        cart.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
    }

    return false;
}
// initial attach
observeCartDrawer();

// re-attach in case theme swaps the drawer DOM later
setInterval(observeCartDrawer, 1500);

})();